export default {
  chat: {
    messages: [],
  },
};
